import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-oee-state-edit',
  templateUrl: './oee-state-edit.component.html',
  styleUrls: ['./oee-state-edit.component.css']
})
export class OeeStateEditComponent implements OnInit {
    oeeStateKeyno;

    public edit?: Edit;

    public selectListColours: ColourItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.oeeStateKeyno = this.stateService.getStateParams()['oeestate_keyno'];
    }

    private async loadEdit() {
        if (!!this.oeeStateKeyno) {
            this.edit = (await this.datatask.Post(241, { oeestate_keyno: this.oeeStateKeyno }))[0];
        }
    }

    private async loadColours() {
        this.selectListColours = await this.datatask.Post(255);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(242, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadColours();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    oeestate_keyno: string;
    oeestate_name: string;
    color_id: string;
    showremark: string;
    showfields: string;
    showprodid: string;
}

interface ColourItem {
    color_id: string;
    color_name: string;
}
